import { io } from "socket.io-client";
import Config from "./config";

// Socket for in-app notifications, served by inventoryapi.
//
// Separate from src/socket.js on purpose - that one points at
// decorassisterp.decorpot.com for GroupChat, which is a different server. This
// one has to reach whichever inventoryapi the rest of the app is talking to.
//
// The URL is derived from Config.apiUrl rather than being a fourth hardcoded
// host, so dev / test / prod follow the existing config with nothing new to
// keep in sync. apiUrl ends in "/api/", which the socket is not under.
const SOCKET_URL = String(Config.apiUrl || "").replace(/\/api\/?$/, "");

let socket = null;

// The server expects the same pako-deflated, base64 token the REST calls send
// (services/middleware.js decompresses it before jwt.verify), so the value in
// localStorage goes across untouched.
const authToken = () => localStorage.getItem("TOKEN_KEY") || "";

// Created lazily: importing this module must not open a connection, or every
// page that happens to pull it in would connect for anonymous visitors too.
export const getNotificationSocket = () => {
    if (!socket) {
        socket = io(SOCKET_URL, {
            path: "/socket.io",
            autoConnect: false,
            // websocket first, but polling is left in as a fallback - some
            // corporate proxies refuse the upgrade, and a bell that silently
            // never connects is worse than one on long-poll transport.
            transports: ["websocket", "polling"],
            // socket.io retries on its own; these just stop it hammering a
            // server that is down and give up politely on a bad token.
            reconnectionAttempts: 10,
            reconnectionDelay: 2000,
            reconnectionDelayMax: 30000,
            auth: { token: authToken() },
        });
    }
    // Re-read on every connect, so a token refreshed since the socket was
    // first built is the one used.
    socket.auth = { token: authToken() };
    return socket;
};

export const disconnectNotificationSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};

export default getNotificationSocket;
